export const SET_TP_CONTACTS_FILTERS_DATA = 'SET_TP_CONTACTS_FILTERS_DATA';
export const setTPContactsFiltersConfigData = (filterData: any) => ({
  type: SET_TP_CONTACTS_FILTERS_DATA,
  payload: filterData,
});

const initialState: any = [];

interface Action {
  type: string;
  payload: any;
}

const tpContactsFiltersDataReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_TP_CONTACTS_FILTERS_DATA:
      return [...action.payload];
    default:
      return state;
  }
};
export default tpContactsFiltersDataReducer;
